import React from "react";
import PaymentSummaryContent from "./PaymentSummaryContent";
import { PaymentSummaryDialogProps } from "./types";
import { useBusinessTheme } from "src/shared/utils/useBusinessTheme";
import { ModalWrapper } from "src/shared/components/ModalWrapper";
import CommonButtons from "src/shared/components/CommonButtons";

const PaymentSummaryDialog: React.FC<PaymentSummaryDialogProps> = ({
  open,
  onClose,
  onBack,
  onCompletePayment,
  isProcessing,
  paymentMethod,
  receivedAmount,
  selectedProducts,
  selectedStaff,
  customerName,
  customerPhone,
  discount,
  tipsAmount,
  onReceivedAmountChange,
  time,
}) => {
  const { loading } = useBusinessTheme();

  if (!open || loading) return null;

  const isButtonDisabled = isProcessing || (paymentMethod === "cash" && (!receivedAmount || parseFloat(receivedAmount) <= 0));

  const handleCompletePayment = async () => {
    onClose();

    try {
      await Promise.resolve(onCompletePayment());
    } catch (err) {
      console.error("Payment completion failed:", err);
    }
  };

  return (
    <ModalWrapper title="Payment Summary" onClose={onClose} onBack={onBack} showCloseButton showBackButton width="max-w-lg">
      <div className="flex flex-col">
        <PaymentSummaryContent
          selectedProducts={selectedProducts}
          selectedStaff={selectedStaff}
          customerName={customerName}
          customerPhone={customerPhone}
          discount={discount}
          tipsAmount={tipsAmount}
          onReceivedAmountChange={onReceivedAmountChange}
          time={time}
          paymentMethod={paymentMethod}
          receivedAmount={receivedAmount}
        />

        {/* Footer Buttons */}
        <div className="flex justify-end gap-3 px-0 py-4 border-t">
          <CommonButtons className="w-36" label="Close" variant="outlineDanger" onClick={onClose}/>
          {/* <button onClick={onClose} className="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100">
            Close
          </button> */}
          <CommonButtons className="w-52" label={isProcessing ? "Processing..." : "Complete Payment"} onClick={handleCompletePayment} disabled={isButtonDisabled}/>
          {/* <button
            onClick={handleCompletePayment}
            disabled={isButtonDisabled}
            className={`px-4 py-2 rounded-lg text-white ${isButtonDisabled ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
          >
            {isProcessing ? "Processing..." : "Complete Payment"}
          </button> */}
        </div>
      </div>
    </ModalWrapper>
  );
};

export default PaymentSummaryDialog;
